import React from 'react'
import { FaCaretDown } from 'react-icons/fa'
import {
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
} from '@chakra-ui/react'

export interface SelectProps extends ChakraSelectProps {
  size?: 'sm' | 'md'
}

export const Select = ({ children, ...baseProps }: SelectProps) => (
  <ChakraSelect
    icon={<FaCaretDown />}
    iconColor="gray.500"
    borderColor="gray.500"
    bg="white"
    {...baseProps}
  >
    {children}
  </ChakraSelect>
)
